"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rating = void 0;
var Rating;
(function (Rating) {
    Rating["NeedsImprovement"] = "Needs Improvement";
    Rating["MeetsExpectations"] = "Meets Expectations";
    Rating["ExceedsExpectations"] = "Exceeds Expectations";
    Rating["Unrated"] = "Unrated";
})(Rating = exports.Rating || (exports.Rating = {}));
//# sourceMappingURL=Rating.js.map